import { PureComponent } from "react";
import { Navigate } from "react-router-dom";
import LocalStorageService from "../auth/local-storage-service";
import HelpdeskPendingTicketOutlet from "../components/design-tools/helpdesk/helpdesk-pending-ticket-outlet";
import { KuikaSpinner } from "../components/design-tools/spinner/kuika-spinner";
import { DomainService } from "../services/domain-service";
import { UserService } from "../services/user-service";
import { KMainFunctions } from "../shared/utility/main-functions";

export interface IPrivateRoutesProps {}

export interface IPrivateRoutesState {
  isAuthLoading: boolean;
  isAuthenticated: boolean;
}

class PrivateRoutes extends PureComponent<IPrivateRoutesProps, IPrivateRoutesState> {
  constructor(props) {
    super(props);
    this.state = {
      isAuthLoading: true,
      isAuthenticated: false
    };
  }

  async componentDidMount() {
    this.setState({ isAuthLoading: true });
    const user = await UserService.GetUserInfo();

    if (user && user.id) {
      this.setState({ isAuthenticated: true });
    } else {
      this.setState({ isAuthenticated: false });
    }

    await this.getDomainInfo();
    this.setState({ isAuthLoading: false });
  }

  getDomainInfo = async () => {
    try {
      const res = await DomainService.GetDomainDetail(LocalStorageService.getCurrentDomain());
      if (res && res.status === 200) {
        const { data } = res;
        // this.props.changeAccessLimitedModalVisibilityStatus(data?.managedDbExists === false);
        LocalStorageService.setDomainAuthInfo(data?.domainAuthorizationOn);
        LocalStorageService.setCurrentDomainManagedDbType(data?.managedDbType);
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      // this.props.changeAccessLimitedModalVisibilityStatus(false);
      LocalStorageService.setDomainAuthInfo("false");
      LocalStorageService.setCurrentDomainManagedDbType();
    }
  };

  render() {
    if (this.state.isAuthLoading) {
      return <KuikaSpinner />;
    }

    if (this.state.isAuthenticated) {
      // `<Outlet />`, plus the detour to a helpdesk link remembered across the login page.
      return <HelpdeskPendingTicketOutlet />;
    }

    return <Navigate to="/login" />;
  }
}

export default PrivateRoutes;
